<template>
  <div class="substep-track-time-using-desktop-app">
    <div class="substep-header">
      <h3 data-testid="step-title">Next, you’ll track time using the Hubstaff desktop app</h3>
      <p>After installing the app you downloaded on the previous step, follow the instructions below to track time</p>
    </div>

    <div class="substep-body">
      <AppAlert
        type="info"
        icon-classes="hi hi-info"
        message="Here's a demo of how to track time using the Hubstaff app"
      />
      <div class="getting-started-tracker-demo">
        <video
          :src="AR0223_TRACKER_VIDEO"
          autoplay
          loop
          muted
          playsinline
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AR0223_TRACKER_VIDEO } from '~/rails_assets';

export default {
  name: 'TrackTimeUsingDesktopApp',
  data: () => ({
    AR0223_TRACKER_VIDEO,
  }),
  mounted() {
    this.$emit('completeSubstep');
  },
};
</script>
